import { render, staticRenderFns } from "./CreatePurchaseMobile.vue?vue&type=template&id=04009172&scoped=true"
import script from "./CreatePurchaseMobile.vue?vue&type=script&lang=js"
export * from "./CreatePurchaseMobile.vue?vue&type=script&lang=js"
import style0 from "./CreatePurchaseMobile.vue?vue&type=style&index=0&id=04009172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04009172",
  null
  
)

export default component.exports